import {IHierarchyRelationship, IHierarchyStructure, INode} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {WB_CustomerRelationshipRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash"
import {esWB_Customer, esWB_Customer_Relationship} from "../PA.Core/PAdbSchema";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {GenericRelation} from "./GenericRelation";

export class CustomerRelation
    implements IHierarchyRelationship {
    private _hierStructure: IHierarchyStructure

    private _child: INode;
    private _parent: INode;
    private _effectiveStartDt: Date;
    private _effectiveEndDt: Date;

    private _bDelete: boolean
    private _original: IHierarchyRelationship

    private _rowWB_Id: number
    private _rowSrcId: string
    private _rowStatus: string
    private _rowModifiedDt: Date

    // Create on Save
    private custRelRow: WB_CustomerRelationshipRow


    constructor(structure: IHierarchyStructure, options?: { relRow?: WB_CustomerRelationshipRow }) {
        this._hierStructure = structure
        this._bDelete = false
        this.custRelRow = options?.relRow

        if (!_.isEmpty(this.custRelRow)) {
            this._child = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Customer, this.custRelRow.cif.WB_CUST_ID)
            this._parent = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Customer, this.custRelRow.cif.WB_CUST_ID_PRNT)
            this._effectiveStartDt = this.custRelRow.EffectiveStartDt
            this._effectiveEndDt = this.custRelRow.EffectiveEndDt
            this._rowWB_Id = this.custRelRow.cif.WB_CUSTR_ID
            this._rowSrcId = this.custRelRow.cif.SOURCE_KEY
            this._rowStatus = this.custRelRow.isActive ? 'Active' : 'Deleted'
            this._rowModifiedDt =DateUtils.convertFromSAPBWTs(this.custRelRow.cif.MODIFIED_DTTS)
        }
        this._original = new GenericRelation(structure, this)
    }

    get hierarchy(): IHierarchyStructure {
        return this._hierStructure
    }

    get child(): INode {
        return this._child
    }

    get parent(): INode {
        return this._parent
    }

    get effectiveEndDt(): Date {
        return this._effectiveEndDt
    }

    get effectiveStartDt(): Date {
        return this._effectiveStartDt
    }

    get isActive(): boolean {
        return !this._bDelete
    }

    get isActiveNew(): boolean {
        return (_.isEmpty(this.custRelRow) && !this._bDelete)
    }

    get isModified(): boolean {
        if (_.isEmpty(this.custRelRow))
            return false

        if (this._bDelete && !_.isEmpty(this.custRelRow))
            return true

        let wbChildId = this.child?.wbId || 0
        let wbParentId = this.parent?.wbId || 0
        let sStartDt = DateUtils.convertToSAPBW(this.effectiveStartDt)
        let sEndDt = DateUtils.convertToSAPBW(this.effectiveEndDt)

        if (this.custRelRow.cif.WB_CUST_ID != wbChildId)
            return true

        if (this.custRelRow.cif.WB_CUST_ID_PRNT != wbParentId)
            return true

        if (this.custRelRow.cif.EFFECTIVE_START_DT != sStartDt)
            return true

        if (this.custRelRow.cif.EFFECTIVE_END_DT != sEndDt)
            return true

        return false
    }

    get original(): IHierarchyRelationship {
        return this._original
    }

    get rowWB_Id(): number {
        return this._rowWB_Id
    }

    get rowSrcId(): string {
        return this._rowSrcId
    }

    get rowStatus(): string {
        return this._rowStatus
    }

    get rowModifiedDt(): Date {
        return this._rowModifiedDt
    }

    setChild(aNode: INode): void {
        this._child = aNode
    }

    setParent(aNode: INode): void {
        this._parent = aNode
    }

    setEffectiveStartDt(aDate: Date): void {
        this._effectiveStartDt = aDate
    }

    setEffectiveEndDt(aDate: Date): void {
        this._effectiveEndDt = aDate
    }

    Delete(): void {
        this._bDelete = true
    }

    async SaveBatch(): Promise<void> {
        const self = this
        if (!self.isModified && !self.isActiveNew)
            return

        // create record if needed
        if (_.isEmpty(self.custRelRow)) {
            if (self._bDelete)
                return
            self.custRelRow = <WB_CustomerRelationshipRow>await self._hierStructure.dbContext.createRecordWithKey(esWB_Customer_Relationship)
            self.custRelRow.setDefaults()
            self.custRelRow.cif.WB_CUSTH_ID = self._hierStructure.wbId
            self._hierStructure.dbContext.add(esWB_Customer_Relationship, self.custRelRow)
        }

        // Currently assumes everything is set..
        // Set child, parent, dates
        if (self._bDelete) {
            self.custRelRow.markDeleted()
        } else {
            self.custRelRow.cif.WB_CUST_ID = (self.child?.wbId || 0)
            self.custRelRow.cif.WB_CUST_ID_PRNT = (self.parent?.wbId || 0)
            self.custRelRow.EffectiveStartDt = self.effectiveStartDt
            self.custRelRow.EffectiveEndDt = self.effectiveEndDt
        }
        await self._hierStructure.dbContext.SaveBatch(esWB_Customer_Relationship, self.custRelRow)

    }


}